import { Injectable } from '@angular/core';
import { Observable, combineLatest, map } from 'rxjs';
import { Institution, InstitutionInCompareGQL } from 'src/generated/graphql';
import { InstitutionInCompare } from '../../models/institution-in-compare';
import { InstitutionInCompareMapper } from '../../mappers/institution-in-compare-mapper';

@Injectable()
export class CompareService {
  constructor(private institutionInCompareGQL: InstitutionInCompareGQL) {}

  public getInstitutionsInCompare(
    institutions: (Institution | null)[]
  ): Observable<InstitutionInCompare[]> {
    const request = institutions.map((institution) => {
      return this.institutionInCompareGQL.fetch(
        {
          id: institution?.id as any,
          opeId: institution?.opeId as string
        },
        { fetchPolicy: 'no-cache' }
      );
    });

    return combineLatest(request).pipe(
      map((responses) => {
        return responses.map(({ data }) => InstitutionInCompareMapper.toDto(data));
      })
    );
  }
}
